
















import {Component, Prop, Vue} from "vue-property-decorator";
import {QuizData} from "@/types/Quiz.ts";

@Component
export default class QuizResultModal extends Vue{
  @Prop() readonly value?: boolean;
  @Prop() readonly currentQuiz?: QuizData;

  nextStep(): void{
    this.$emit('next', true)
  }
}
